export default "__VITE_ASSET__0e8bc97c__"